import React from "react";
import WebView from "./ViewItems/WebView";
import MobileView from "./ViewItems/MobileView";
import MediumView from "./ViewItems/MediumView";

const UserGroupsList = (props) => {
  const { membershipTypes, deleteMembershipTypePending, onDeleteUserGroup, currentUrl, getList } =
    props;
  return (
    <>
      <div className="off-canvas-wrapper">
        <div
          id="inb-c-main-users"
          className="inb-c-listing off-canvas-content"
          data-off-canvas-content=""
        >
          {membershipTypes.map((usergroup, index) => {
            return (
              <>
                <WebView
                  usergroup={usergroup}
                  index={index}
                  deleteUserGroupPending={deleteMembershipTypePending}
                  onDeleteUserGroup={onDeleteUserGroup}
                  currentUrl={currentUrl}
                  getList={getList}
                />

                <MediumView
                  usergroup={usergroup}
                  index={index}
                  deleteUserGroupPending={deleteMembershipTypePending}
                  onDeleteUserGroup={onDeleteUserGroup}
                  currentUrl={currentUrl}
                  getList={getList}
                />

                <MobileView
                  usergroup={usergroup}
                  index={index}
                  deleteUserGroupPending={deleteMembershipTypePending}
                  onDeleteUserGroup={onDeleteUserGroup}
                  currentUrl={currentUrl}
                  getList={getList}
                />
              </>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default UserGroupsList;
